<div class="payment-method-page">
  @if(isLoading) {
    <app-loading-page [message]="loadingMessage"></app-loading-page>
  }
  @else {
    <!-- Top Bar -->
    <div class="top-bar">
      <button kendoButton 
              class="btn btn--small btn--outline" 
              [disabled]="isSubmitting"
              (click)="onBack()">
        Back
      </button>
    </div>

    <div class="content-container">
      <div class="header">
        <h1>Payment method</h1>
        <p class="subtitle">Update your payment method for future billing</p>
      </div>

      <!-- Existing Payment Methods -->
      @for(method of paymentMethods; track method.id) {
        <label class="payment-method-option" 
               [class.selected]="selectedPaymentMethodId === method.id"
               [class.disabled]="isSubmitting">
          <div class="radio-wrapper">
            <input
              type="radio"
              [id]="method.id"
              name="paymentMethod"
              [value]="method.id"
              [checked]="selectedPaymentMethodId === method.id"
              [disabled]="isSubmitting"
              (change)="onPaymentMethodSelect(method.id)"
            />
            <div class="payment-method-content">
              @if(method.card) {
                <img [src]="method.cardIconUrl" [alt]="method.card.brand" class="card-brand-icon" />
                <span class="card-details">
                  {{ method.card.brand }} •••• {{ method.card.last4 }}
                  @if(method.expiryDisplay) {
                    <span class="expiry">Expires {{ method.expiryDisplay }}</span>
                  }
                </span>
              }
            </div>
          </div>
        </label>
      }

      <!-- Add New Payment Method Option -->
      <label class="payment-method-option" 
             [class.selected]="isAddingNewCard"
             [class.disabled]="isSubmitting">
        <div class="radio-wrapper">
          <input
            type="radio"
            id="new-card"
            name="paymentMethod"
            [checked]="isAddingNewCard"
            [disabled]="isSubmitting"
            (change)="onAddNewCard()"
          />
          <div class="payment-method-content">
            @if(isStripeLoading) {
              <span class="loading-spinner">Loading payment form...</span>
            } @else {
              Add payment method
            }
          </div>
        </div>
      </label>

      <!-- Stripe Payment Element Container -->
      <div class="payment-element-container" [class.visible]="isAddingNewCard && !isStripeLoading">
        <form (submit)="onSubmit()">
          <div id="payment-element"></div>
        </form>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <button kendoButton 
                [primary]="true"
                [disabled]="!isUpdateAllowed() || isStripeLoading || isSubmitting"
                (click)="onSubmit()">
          @if(isSubmitting) {
            <span class="k-icon k-i-loading"></span>
            Updating...
          } @else {
            Update
          }
        </button>
        <button kendoButton 
                [disabled]="isSubmitting"
                (click)="onBack()">
          Cancel
        </button>
      </div>
    </div>
  }
</div> 